import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Card, Table } from 'react-bootstrap';
import URI from 'urijs';
import LoadingOverlay from '../LoadingOverlay';

const UserPropertyGroup = (props) => {
  const [loading, setLoading] = useState(false);
  const [propertyGroups, setPropertyGroups] = useState([]);

  useEffect(() => {
    const fetchPropertyGroups = async () => {
      try {
        setLoading(true);
        const url = new URI(
          `${process.env.REACT_APP_PROPERTIES_API_URL}api/admin/user/property-groups`
        );
        url.addQuery('user_id', props.user_id);
        url.addQuery('user_type', props.user_type);
        const response = await fetch(url.toString(), {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            SeasonalDatabase: props.selectedDatabase,
            Authorization: `Bearer ${props.bearerToken}`
          }
        });
        if (!response.ok) {
          if (response.status === 401) {
            props.refreshBearerToken();
            return;
          }
          throw new Error(response.statusText);
        }
        const data = await response.json();
        setPropertyGroups(data || []);
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          console.error(error);
        }
        setPropertyGroups([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPropertyGroups();
  }, [
    props.bearerToken,
    props.selectedDatabase,
    props.user_id,
    props.user_type,
    props.refreshBearerToken
  ]);

  return (
    <Card>
      <Card.Header
        style={{ height: '63px' }}
        className='d-flex align-items-center'
      >
        Property Groups ({props.selectedDatabase})
      </Card.Header>
      <Card.Body>
        {loading ? (
          <LoadingOverlay />
        ) : (
          <Table>
            <thead>
              <tr>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              {propertyGroups.length > 0 ? (
                propertyGroups.map((propertyGroup, i) => (
                  <tr key={i}>
                    <td>{propertyGroup.name}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className='text-center'>No property groups found</td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
};

UserPropertyGroup.propTypes = {
  selectedDatabase: PropTypes.string.isRequired,
  bearerToken: PropTypes.string.isRequired,
  refreshBearerToken: PropTypes.func.isRequired,
  user_id: PropTypes.string.isRequired,
  user_type: PropTypes.string.isRequired
};

export default UserPropertyGroup;
